import { createContext } from "react"

import { PacOption } from "@/components/TopNavigation/components/MultiPacSelector/types"

type ContextType = {
    selectedPac: string
    options: PacOption[]
    selectNewPac: (newPac: string) => void
    selectedPacLabel: string
    search: string
    setSearch: (value: string) => void
    isLoading: boolean
}

export const MultiPacSelectorContext = createContext<ContextType>({} as ContextType)
